import { useContext, useEffect, useState } from "react";
import { getDraft } from "../components/DatasetManager/DraftApi";
import { AuthContext } from "../components/App/Main";
/**
 * Fetch the DraftItem identified by `draftId` once and return it.
 *
 * Components that need the draft's `draft_graph_uri` to scope SPARQL reads
 * (UnifiedSearch in draftEdit mode, EntityFormPage) use this. Returns
 * `null` while loading and when no `draftId` is provided.
 *
 * Errors are swallowed (logged to console) — the caller's behavior in the
 * absence of a loaded draft is "don't wrap queries", which is the same as
 * the non-draft browsing path.
 */
export function useDraftStatus(draftId) {
    const authContext = useContext(AuthContext);
    const [draft, setDraft] = useState(null);
    const [loading, setLoading] = useState(!!draftId);
    useEffect(() => {
        if (!draftId) {
            setDraft(null);
            setLoading(false);
            return;
        }
        let cancelled = false;
        setLoading(true);
        getDraft(authContext?.authTokens?.apiToken, draftId)
            .then((res) => {
            if (!cancelled) {
                setDraft(res.data);
                setLoading(false);
            }
        })
            .catch((err) => {
            if (!cancelled) {
                console.error("useDraft: failed to load draft", draftId, err);
                setDraft(null);
                setLoading(false);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [draftId, authContext?.authTokens?.apiToken]);
    return { draft, loading };
}
export function useDraft(draftId) {
    return useDraftStatus(draftId).draft;
}
